module.exports = __webpack_public_path__ + "static/media/unsplash-parkinglot-herphone.83b9b6ae.jpg";